import { Directive, HostBinding } from '@angular/core';
/**
 * Represents the Kendo UI TextBox directive for the Inputs components for Angular.
 *
 * Used to style the textbox of any `input` element.
 *
 * @example
 * ```ts-no-run
 * <input kendoTextBox />
 * <input kendoTextBox type="email" />
 * <input kendoTextBox type="password" />
 * ```
 */
var TextBoxDirective = (function () {
    function TextBoxDirective() {
    }
    Object.defineProperty(TextBoxDirective.prototype, "hostClass", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    return TextBoxDirective;
}());
export { TextBoxDirective };
TextBoxDirective.decorators = [
    { type: Directive, args: [{
                selector: 'input[kendoTextBox]'
            },] },
];
/** @nocollapse */
TextBoxDirective.ctorParameters = function () { return []; };
TextBoxDirective.propDecorators = {
    'hostClass': [{ type: HostBinding, args: ['class.k-textbox',] },],
};



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-inputs/dist/es/textbox/textbox.directive.js
// module id = ../../../../@progress/kendo-angular-inputs/dist/es/textbox/textbox.directive.js
// module chunks = 3